(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],2:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _customFormatTypes = _interopRequireDefault(require("./utils/_customFormatTypes"));
/**
 * Custom admin scripts
 * @package concept83
 * @since 1.0
 */

var _wp = wp,
  domReady = _wp.domReady,
  setDefaultBlockName = _wp.blocks.setDefaultBlockName;
domReady(function () {
  return setDefaultBlockName('cnc83/text');
});
document.addEventListener('DOMContentLoaded', (0, _customFormatTypes.default)());

},{"./utils/_customFormatTypes":3,"@babel/runtime/helpers/interopRequireDefault":1}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Custom format types
 * @package concept83
 * @since 1.0
 */

function customFormatTypes() {
  var RichTextToolbarButton = wp.blockEditor.RichTextToolbarButton;
  var _wp$richText = wp.richText,
    registerFormatType = _wp$richText.registerFormatType,
    toggleFormat = _wp$richText.toggleFormat;
  var underlineFormat = 'cnc83/underline';
  registerFormatType(underlineFormat, {
    title: 'Underline',
    tagName: 'u',
    className: null,
    edit: function edit(props) {
      var isActive = props.isActive,
        onChange = props.onChange,
        value = props.value;
      return /*#__PURE__*/React.createElement(RichTextToolbarButton, {
        title: "Underline",
        icon: "editor-underline",
        onClick: function onClick() {
          onChange(toggleFormat(value, {
            type: underlineFormat
          }));
        },
        isActive: isActive
      });
    }
  });
}
var _default = exports.default = customFormatTypes;

},{}]},{},[2]);
